const collapsibles = document.querySelectorAll('button.collapsible');

collapsibles.forEach(button => {

    const content = button.nextElementSibling;
    const inner = content.querySelector('.inner-content');

    // Toggle collapsible
    button.addEventListener('click', () => {
        button.classList.toggle('active');
        if (content.style.maxHeight) {
            content.style.maxHeight = null;
        } else {
            content.style.maxHeight = inner.scrollHeight + "px";
        }
    });

    
    // Observe content height changes
    const observer = new ResizeObserver(() => {
        if (button.classList.contains('active')) {
            content.style.maxHeight = inner.scrollHeight + "px";
        }
    });

    observer.observe(inner);
});